export const ESTATUS: string[] = [
    'Pendiente',
    'VoBo',
    'Aclaracion',
  ];